// extracted by mini-css-extract-plugin
module.exports = {"red":"Cockpit_red__3GSoJ","bold":"Cockpit_bold__3urf2","Cockpit":"Cockpit_Cockpit__snX-D","Red":"Cockpit_Red__2ee36"};